import classNames from 'classnames';
import { FC, ReactElement, ReactNode } from 'react';
import { Stack } from '@legacy/components/mui-components';
import styles from './Deck.module.scss';
import { useNavigationStore } from '@/stores/navigation';
import { useHasNewNavigation } from '@/hooks/featureFlags';

export interface DeckInterface {
  (props: DeckProps): ReactElement;
  Item: FC<DeckItem>;
}

interface DeckProps {
  children: ReactNode;
  backgroundColor?: boolean;
  noPaddingTop?: boolean;
  noPaddingBottom?: boolean;
  hasBorderTop?: boolean;
  isSimple?: boolean;
}

interface DeckItem {
  children: ReactNode;
  hasOverflow?: boolean;
  zIndex?: 1 | 2 | 3;
}

export const Deck: DeckInterface = ({
  children,
  backgroundColor,
  noPaddingTop,
  noPaddingBottom,
  hasBorderTop,
  isSimple,
  ...props
}) => (
  <div
    className={classNames(styles.wrapper, {
      [styles.bg]: backgroundColor,
      [styles.noPaddingTop]: noPaddingTop,
      [styles.noPaddingBottom]: noPaddingBottom,
      [styles.hasBorderTop]: hasBorderTop,
      [styles.isSimple]: isSimple,
    })}
    {...props}
  >
    <Stack gap={2} className={styles.inner}>
      {children}
    </Stack>
  </div>
);

Deck.Item = ({ hasOverflow, zIndex, ...props }): ReactElement => {
  const hasNewNavigation = useHasNewNavigation();

  const { isCollapsed } = useNavigationStore();

  return (
    <Stack
      gap={2}
      className={classNames(styles.item, {
        [styles.overflow]: hasOverflow,
        [styles.isInNewNavigation]: hasNewNavigation && !isCollapsed,
        // [styles[`Deck__item____${zIndex}` as keyof typeof styles]]: zIndex,
      })}
      {...props}
    />
  );
};
